import { RefreshCcw } from 'lucide-react';
import { useState } from 'react';

type Props = {
  disabled?: boolean;
  className?: string;
};

export default function DateYearInput({ disabled, className }: Props) {
  const [value, setValue] = useState('');

  const reset = () => setValue('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const year = e.target.value.split('-')[0]; // extract year
    setValue(year);
  };

  return (
    <div className="flex items-center gap-2 w-full">
      <input
        type="date"
        value={value ? `${value}-01-01` : ''}
        onChange={handleChange}
        disabled={disabled}
        className={className}
      />

      <button type="button" onClick={reset} className="text-[#7a3a4c]">
        <RefreshCcw size={18} />
      </button>
    </div>
  );
}
